
(function calendarControllerDefinition() {
    'use strict';

    angular.module('Calendar')
        .constant("moment", moment)
        .controller('CalendarController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'authExtend', 'storageService', 'documentTypeService', '$filter',
            function calendarController($scope, config, $state, $translate, errors, authExtend, storageService, documentTypeService, $filter) {
                $scope.aux = storageService.getCalendarFilter();

                documentTypeService.get('CALENDAR READ', true).then(function (result) {
                    $scope.optionsDocumentTypes = result;
                }, function (error) {
                    errors.showError(error);
                });

                $scope.selectDocumentType = function () {
                    storageService.setCalendarFilter($scope.aux);
                    $scope.docTypeId = $scope.aux.documentType.id;
                }

                $scope.redirectEvent = function (eventDate) {
                    documentTypeService.getById($scope.docTypeId).then(function (result) {
                        $scope.find = storageService.clearDocumentFilter();
                        $scope.find = storageService.getDocumentFilter();

                        var selectedMetadata = $filter('filter')(result.metadata, { useCalendar: true }, true)[0];

                        selectedMetadata.metadataValueFrom = eventDate;
                        selectedMetadata.metadataValueTo = eventDate;
                        selectedMetadata.metadataSearchTypeFrom = 'GreaterThanOrEqual';
                        selectedMetadata.metadataSearchTypeTo = 'LessThanOrEqual';
                        result.documentTypeId = result.id;                        
                        result.documentTypeName = result.name;
                        result.metadatas = $filter('filter')(result.metadata, { isSearchCriteria: true }, true);
                        delete result.metadata;

                        result.metadatas.forEach(function (item) {
                            item.idObject = result.id + '' + item.metadataId;
                        });

                        $scope.find.selectedDocumentTypes.push(result);
                        $scope.find.DocumentTypes.push(result);
                        $scope.find.fromCalendar = true;
                        $scope.aux.filterDate = moment(eventDate);
                        storageService.setCalendarFilter($scope.aux);
                        storageService.setDocumentFilter($scope.find);

                        $state.go('document-advanced-find');
                    }, function (error) {
                        errors.showError(error);
                    });
                }

                if ($scope.aux.documentType) {
                    $scope.selectDocumentType();
                }
            }
        ]);
})();